import type { TrackEventPayload } from '@/lib/api/analytics';
import { detectBrowserName, detectDeviceType, truncate } from '@/lib/utils/analytics';
import { getOrCreateAuthenticatedSessionId } from '@/lib/utils/analytics-session';

export function buildPageViewEventPayload(
  pathname: string,
  search: string,
  referrer: string,
  userAgent: string
): TrackEventPayload {
  const pageUrl = truncate(`${pathname}${search}`, 500);
  const normalizedReferrer = truncate(referrer === '' ? undefined : referrer, 500);
  const normalizedUserAgent = truncate(userAgent, 1000);

  return {
    event_type: 'page_view',
    event_category: 'navigation',
    session_id: getOrCreateAuthenticatedSessionId(),
    ...(pageUrl === undefined ? {} : { page_url: pageUrl }),
    ...(normalizedReferrer === undefined ? {} : { referrer: normalizedReferrer }),
    ...(normalizedUserAgent === undefined ? {} : { user_agent: normalizedUserAgent }),
    device_type: detectDeviceType(userAgent),
    browser: detectBrowserName(userAgent),
  };
}
